import { render, staticRenderFns } from "./MenuRightModular.vue?vue&type=template&id=8b3df22c"
import script from "./MenuRightModular.vue?vue&type=script&lang=js"
export * from "./MenuRightModular.vue?vue&type=script&lang=js"
import style0 from "./MenuRightModular.vue?vue&type=style&index=0&id=8b3df22c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports